/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import { CodeableConceptFieldsFragmentDoc, QuantityFieldsFragmentDoc, ObservationComponentFieldsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListAlertsQueryVariables = Types.Exact<{
  input: Types.ListAlertsInput;
  is_vitall?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ListAlertsQuery = { __typename?: 'Query', listAlerts: Array<{ __typename?: 'AlertModel', alert_id: string, status: Types.AlertStatus, created_at: string, account_id?: string | null, vitall_patient_id?: string | null, observation_id?: string | null, vitall_patient?: { __typename?: 'VitallPatientModel', vitall_patient_id: string, user?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string } | null } | null, measurement?: { __typename?: 'ObservationModel', id?: string | null, resourceType?: string | null, status: string, category?: Array<{ __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null, userSelected?: boolean | null }> | null }> | null, code: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null, userSelected?: boolean | null }> | null }, valueQuantity?: { __typename?: 'Quantity', value?: number | null, comparator?: string | null, unit?: string | null, system?: string | null, code?: string | null } | null, component?: Array<{ __typename?: 'ObservationComponent', valueString?: string | null, valueBoolean?: boolean | null, valueInteger?: number | null, valueDateTime?: string | null, code: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null, userSelected?: boolean | null }> | null }, valueQuantity?: { __typename?: 'Quantity', value?: number | null, comparator?: string | null, unit?: string | null, system?: string | null, code?: string | null } | null, valuePeriod?: { __typename?: 'Period', start?: string | null, end?: string | null } | null } | null> | null } | null, reference_range?: { __typename?: 'AlertReferenceRangeModel', reference_range_id: string, category?: string | null, code: string, parameters: Array<{ __typename?: 'AlertRiskParameterModel', risk: Types.ReferenceRangeRiskLevel, parameter_id: string, vitall_patient_id?: string | null, code: string, lower_bound?: { __typename?: 'ParameterBoundary', inclusive: boolean, value: number } | null, upper_bound?: { __typename?: 'ParameterBoundary', inclusive: boolean, value: number } | null }> } | null, notification_count?: { __typename?: 'AlertNotificationCountModel', successes: number, fails: number, not_delivered: number } | null, cleared_alert_user?: { __typename?: 'UserModel', user_id: string, first_name: string, last_name: string } | null }> };

export type GetAlertStatsQueryVariables = Types.Exact<{
  input: Types.GetMetricAlertStatsInput;
}>;


export type GetAlertStatsQuery = { __typename?: 'Query', getAlertStats: { __typename?: 'AlertStatsModel', count: number, last_update?: string | null } };

export type ListAlertNotificationsQueryVariables = Types.Exact<{
  input: Types.ListAlertNotificationsInput;
}>;


export type ListAlertNotificationsQuery = { __typename?: 'Query', listAlertNotifications: Array<{ __typename?: 'AlertNotificationModel', recipient_id: string, type: Types.AlertRecipientType, name: string, email_notification?: { __typename?: 'AlertNotificationDestinationModel', destination: string, error_message?: string | null, sent_at?: string | null, status: Types.AlertNotificationStatus } | null, sms_notification?: { __typename?: 'AlertNotificationDestinationModel', destination: string, error_message?: string | null, sent_at?: string | null, status: Types.AlertNotificationStatus } | null }> };

export type UpdateAlertsMutationVariables = Types.Exact<{
  input: Types.UpdateAlertsInput;
}>;


export type UpdateAlertsMutation = { __typename?: 'Mutation', updateAlerts: Array<{ __typename?: 'UpdatedAlertModel', alert_id: string, observation_id?: string | null, vitall_patient_id?: string | null }> };


export const ListAlertsDocument = gql`
    query listAlerts($input: ListAlertsInput!, $is_vitall: Boolean = false) {
  listAlerts(input: $input) {
    alert_id
    status
    created_at
    account_id
    vitall_patient_id
    vitall_patient {
      vitall_patient_id
      user {
        user_id
        first_name
        last_name
      }
    }
    observation_id
    measurement {
      id
      resourceType
      status
      category {
        ...CodeableConceptFields
      }
      code {
        ...CodeableConceptFields
      }
      valueQuantity {
        ...QuantityFields
      }
      component {
        ...ObservationComponentFields
      }
    }
    reference_range {
      reference_range_id
      category
      code
      parameters {
        risk
        parameter_id
        vitall_patient_id
        code
        lower_bound {
          inclusive
          value
        }
        upper_bound {
          inclusive
          value
        }
      }
    }
    notification_count @include(if: $is_vitall) {
      successes
      fails
      not_delivered
    }
    cleared_alert_user @include(if: $is_vitall) {
      user_id
      first_name
      last_name
    }
  }
}
    ${CodeableConceptFieldsFragmentDoc}
${QuantityFieldsFragmentDoc}
${ObservationComponentFieldsFragmentDoc}`;
export function useListAlertsQuery(baseOptions: Apollo.QueryHookOptions<ListAlertsQuery, ListAlertsQueryVariables> & ({ variables: ListAlertsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAlertsQuery, ListAlertsQueryVariables>(ListAlertsDocument, options);
      }
export function useListAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAlertsQuery, ListAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAlertsQuery, ListAlertsQueryVariables>(ListAlertsDocument, options);
        }
// @ts-ignore
export function useListAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAlertsQuery, ListAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAlertsQuery, ListAlertsQueryVariables>;
export function useListAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAlertsQuery, ListAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAlertsQuery | undefined, ListAlertsQueryVariables>;
export function useListAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAlertsQuery, ListAlertsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAlertsQuery, ListAlertsQueryVariables>(ListAlertsDocument, options);
        }
export type ListAlertsQueryHookResult = ReturnType<typeof useListAlertsQuery>;
export type ListAlertsLazyQueryHookResult = ReturnType<typeof useListAlertsLazyQuery>;
export type ListAlertsSuspenseQueryHookResult = ReturnType<typeof useListAlertsSuspenseQuery>;
export type ListAlertsQueryResult = Apollo.QueryResult<ListAlertsQuery, ListAlertsQueryVariables>;
export const GetAlertStatsDocument = gql`
    query getAlertStats($input: GetMetricAlertStatsInput!) {
  getAlertStats(input: $input) {
    count
    last_update
  }
}
    `;
export function useGetAlertStatsQuery(baseOptions: Apollo.QueryHookOptions<GetAlertStatsQuery, GetAlertStatsQueryVariables> & ({ variables: GetAlertStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertStatsQuery, GetAlertStatsQueryVariables>(GetAlertStatsDocument, options);
      }
export function useGetAlertStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertStatsQuery, GetAlertStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertStatsQuery, GetAlertStatsQueryVariables>(GetAlertStatsDocument, options);
        }
// @ts-ignore
export function useGetAlertStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAlertStatsQuery, GetAlertStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAlertStatsQuery, GetAlertStatsQueryVariables>;
export function useGetAlertStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlertStatsQuery, GetAlertStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAlertStatsQuery | undefined, GetAlertStatsQueryVariables>;
export function useGetAlertStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlertStatsQuery, GetAlertStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlertStatsQuery, GetAlertStatsQueryVariables>(GetAlertStatsDocument, options);
        }
export type GetAlertStatsQueryHookResult = ReturnType<typeof useGetAlertStatsQuery>;
export type GetAlertStatsLazyQueryHookResult = ReturnType<typeof useGetAlertStatsLazyQuery>;
export type GetAlertStatsSuspenseQueryHookResult = ReturnType<typeof useGetAlertStatsSuspenseQuery>;
export type GetAlertStatsQueryResult = Apollo.QueryResult<GetAlertStatsQuery, GetAlertStatsQueryVariables>;
export const ListAlertNotificationsDocument = gql`
    query listAlertNotifications($input: ListAlertNotificationsInput!) {
  listAlertNotifications(input: $input) {
    recipient_id
    type
    name
    email_notification {
      destination
      error_message
      sent_at
      status
    }
    sms_notification {
      destination
      error_message
      sent_at
      status
    }
  }
}
    `;
export function useListAlertNotificationsQuery(baseOptions: Apollo.QueryHookOptions<ListAlertNotificationsQuery, ListAlertNotificationsQueryVariables> & ({ variables: ListAlertNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAlertNotificationsQuery, ListAlertNotificationsQueryVariables>(ListAlertNotificationsDocument, options);
      }
export function useListAlertNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAlertNotificationsQuery, ListAlertNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAlertNotificationsQuery, ListAlertNotificationsQueryVariables>(ListAlertNotificationsDocument, options);
        }
// @ts-ignore
export function useListAlertNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAlertNotificationsQuery, ListAlertNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAlertNotificationsQuery, ListAlertNotificationsQueryVariables>;
export function useListAlertNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAlertNotificationsQuery, ListAlertNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAlertNotificationsQuery | undefined, ListAlertNotificationsQueryVariables>;
export function useListAlertNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAlertNotificationsQuery, ListAlertNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAlertNotificationsQuery, ListAlertNotificationsQueryVariables>(ListAlertNotificationsDocument, options);
        }
export type ListAlertNotificationsQueryHookResult = ReturnType<typeof useListAlertNotificationsQuery>;
export type ListAlertNotificationsLazyQueryHookResult = ReturnType<typeof useListAlertNotificationsLazyQuery>;
export type ListAlertNotificationsSuspenseQueryHookResult = ReturnType<typeof useListAlertNotificationsSuspenseQuery>;
export type ListAlertNotificationsQueryResult = Apollo.QueryResult<ListAlertNotificationsQuery, ListAlertNotificationsQueryVariables>;
export const UpdateAlertsDocument = gql`
    mutation updateAlerts($input: UpdateAlertsInput!) {
  updateAlerts(input: $input) {
    alert_id
    observation_id
    vitall_patient_id
  }
}
    `;
export type UpdateAlertsMutationFn = Apollo.MutationFunction<UpdateAlertsMutation, UpdateAlertsMutationVariables>;
export function useUpdateAlertsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlertsMutation, UpdateAlertsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlertsMutation, UpdateAlertsMutationVariables>(UpdateAlertsDocument, options);
      }
export type UpdateAlertsMutationHookResult = ReturnType<typeof useUpdateAlertsMutation>;
export type UpdateAlertsMutationResult = Apollo.MutationResult<UpdateAlertsMutation>;
export type UpdateAlertsMutationOptions = Apollo.BaseMutationOptions<UpdateAlertsMutation, UpdateAlertsMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListAlerts = withQueryResponseHandler(useListAlertsQuery);
export const useGetAlertStats = withQueryResponseHandler(useGetAlertStatsQuery);
export const useListAlertNotifications = withQueryResponseHandler(useListAlertNotificationsQuery);
export const useUpdateAlerts = withMutationResponseHandler(useUpdateAlertsMutation, "updateAlerts");